import css from '../../../utils/css';

export default css`
  @font-face {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 300;
    font-stretch: normal;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/ibmplexsans/v23/zYXGKVElMYYaJe8bpLHnCwDKr932-G7dytD-Dmu1swZSAXcomDVmadSDtFlzAA.ttf)
      format('truetype');
  }
  @font-face {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 400;
    font-stretch: normal;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/ibmplexsans/v23/zYXGKVElMYYaJe8bpLHnCwDKr932-G7dytD-Dmu1swZSAXcomDVmadSD6llzAA.ttf)
      format('truetype');
  }
  @font-face {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 500;
    font-stretch: normal;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/ibmplexsans/v23/zYXGKVElMYYaJe8bpLHnCwDKr932-G7dytD-Dmu1swZSAXcomDVmadSD2FlzAA.ttf)
      format('truetype');
  }
  @font-face {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 700;
    font-stretch: normal;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/ibmplexsans/v23/zYXGKVElMYYaJe8bpLHnCwDKr932-G7dytD-Dmu1swZSAXcomDVmadSDDV5zAA.ttf)
      format('truetype');
  }

  :host {
    --widget-font-family: 'IBM Plex Sans', sans-serif;

    --joe-black: #132428;
    --joe-black-seethrough: #13242833;
    --joe-yellow: #ffc627;
    --joe-white: #fff;

    --widget-background-color: var(--joe-white);

    --widget-text-color: var(--joe-black);
    --widget-border-color: var(--joe-black);
    --widget-divider-color: var(--joe-black-seethrough);

    --widget-header-bg-color: var(--joe-black);
    --widget-header-text-color: var(--joe-yellow);
    --widget-header-odds-shadow: #ccc;

    --widget-grid-compare-active-bg-color: var(--joe-yellow);
    --widget-grid-compare-color: var(--joe-black);

    --widget-mobile-seeall-color: var(--joe-black);

    --widget-grid-best-odds-bg-color: var(--joe-yellow);
    --widget-grid-best-odds-border-color: var(--joe-yellow);
    --widget-grid-best-odds-text-color: var(--joe-black);

    [class*='bestOddsStyles'] svg path:first-child {
      fill: currentColor;
    }
  }
`;
